/* eslint-disable */
import styles from './index.module.scss'
import React, { useState, useLayoutEffect } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { MagazineCard } from '../../components/core/cards'
import { Issue, SlideArrow } from '../../icons'
import 'swiper/css'
import 'swiper/css/pagination'
import './styles.css'

export default function Slider({ title, data, len }) {
  const [my_swiper, set_my_swiper] = useState({})
  const [end, setEnd] = useState(false)
  const [current, setCurrent] = useState(4)
  const [width, setWidth] = useState(false)
  useLayoutEffect(() => {
    function updateSize() {
      if (window.innerWidth <= 768) {
        setWidth(true)
        return
      }
      setWidth(false)
    }

    window.addEventListener('resize', updateSize)
    updateSize()
  }, [])
  return (
    <>
      <div className={styles['slider-header']}>
        <h2>
          <Issue /> {title}
        </h2>
        {len > 4 && !width ? (
          <div>
            <span
              style={
                current < 5 ? { opacity: '0.5', pointerEvents: 'none' } : null
              }
              onClick={() => {
                let x = current - 1
                setCurrent(x)
                my_swiper.slidePrev()
                setEnd(false)
              }}
            >
              <SlideArrow />
            </span>
            <span
              style={end ? { opacity: '0.5', pointerEvents: 'none' } : null}
              onClick={() => {
                let x = current + 1
                setCurrent(x)
                my_swiper.slideNext()
              }}
            >
              <SlideArrow />
            </span>
          </div>
        ) : null}
      </div>
      <Swiper
        onInit={(ev) => {
          set_my_swiper(ev)
        }}
        onReachEnd={() => {
          setEnd(true)
        }}
        slidesPerView={width ? 'auto' : 4}
        spaceBetween={32}
        className="magazine-slider"
      >
        {data.map((item) => (
          <SwiperSlide key={item.id}>
            <MagazineCard
              to={'#'}
              img={item.image}
              title={item.title}
              label={item.label}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </>
  )
}
